export enum DrawModalityEnum {
	FLAT_DRAW = "Flat (Draw)",
	HOURLY_DRAW = "Hourly (Draw)",
	COMMISSION_DRAW = "Commission (Draw)",
	COMMISSION_ONLY_NO_DRAW = "Commission Only (No Draw)",
}
